import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import PaymentTypeText from 'components/ach/paymentTypes/common/payments/PaymentTypeText';
import get from 'lodash/get';
import find from 'lodash/find';

import LocaleContext from '../../locale/LocaleContext';

const PaymentTypeComponent = ({ formChange, formState, options, preSelect, preloaded }) => {
  const locale = useContext(LocaleContext);
  const flatOptions = options.reduce((acc, curr) => {
    return [...acc, ...(Array.isArray(curr.child) ? curr.child : [])];
  }, []);
  // TODO: Investigate why this is matching on hard coded strings (name), and not the ids
  const selectOption = find(flatOptions, { name: preSelect[0]?.name }, []);
  const getValue = () => {
    const value = get(formState, `${preloaded ? 'paymentType' : 'paymentType.0.id'}`);
    const property = preloaded ? 'type' : 'id';
    return [].concat(...options.map((x) => x.child)).find((c) => c[property] === value);
  };

  const defValue = getValue() || { ...preSelect[0], ...selectOption };

  useEffect(() => {
    formChange('paymentType', defValue?.name);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <PaymentTypeText label={locale['create.payment.type']} value={defValue?.name} />
    </div>
  );
};

PaymentTypeComponent.propTypes = {
  formState: PropTypes.shape({}).isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  preSelect: PropTypes.arrayOf(PropTypes.shape({})),
  preloaded: PropTypes.bool
};

PaymentTypeComponent.defaultProps = {
  preSelect: [],
  preloaded: false
};

export default PaymentTypeComponent;
